import { Alert, Button, Spin } from 'antd'
import { useSelectedWorkareaPricing } from '../../../domain/workareas/workareaPricingQueries'
import { useContext } from "react"
import { PricingTypes } from "../../../common/constants"
import JobFinancialsSection from "../../JobFinancials/JobFinancialsSection"
import { ItemsContext } from "../ItemsRoot"
import { buildJobCostingPricingSelections, mergeWorkareaContext, JobCostingWorkarea, VisitFilter, calculateJobFinancialsData, filterItems } from "./jobCostingModel"
import { useCompletedWorkareaVisitsQuery } from "../../../domain/invoicing/invoicingQueries"

type Props = {
  workareas: JobCostingWorkarea[],
  enabledWorkareaIds: number[]
  visitFilters: VisitFilter[]
}

const JobCosting = ({ workareas, enabledWorkareaIds, visitFilters }: Props) => {
  const { changeSet, jobItemsQuery, jobData: { jobId, visitData, workareas: contextWorkareas } } = useContext(ItemsContext)
  const estimatedItems = jobItemsQuery.data?.estimatedItems ?? []
  const actualItems = jobItemsQuery.data?.actualItems ?? []
  const completedWorkareaVisitsQuery = useCompletedWorkareaVisitsQuery(jobId, workareas.some(x => x.pricingType === PricingTypes.PerVisit))

  const filtered = filterItems({
    estimatedItems,
    actualItems,
    workareas: mergeWorkareaContext(workareas, contextWorkareas),
    changeSet,
    enabledWorkareaIds,
    visitFilters
  })

  const enabled = filtered.workareas.some(x => !!x.pricing)
  const selections = buildJobCostingPricingSelections(filtered, visitFilters, visitData, completedWorkareaVisitsQuery.data ?? [])
  const pricing = useSelectedWorkareaPricing(jobId, selections, enabled)
  const hasChanges = changeSet.addedItems.length + changeSet.updatedItems.length + changeSet.deletedItems.length > 0
  if (enabled && hasChanges) {
    return <Alert type="info" message="Save item changes to refresh job costing." />
  }
  if (enabled && pricing.isError) {
    return <Alert type="error" message="Unable to load work area pricing." action={<Button onClick={() => pricing.refetch()}>Retry</Button>} />
  }
  if (enabled && pricing.isLoading) {
    return <Spin tip="Calculating pricing" />
  }
  const data = calculateJobFinancialsData(filtered, completedWorkareaVisitsQuery.data ?? [], enabled ? pricing.data : undefined)
  return <><div role="status">{enabled && pricing.isFetching && "Refreshing pricing…"}</div><JobFinancialsSection data={data} /></>
}

export default JobCosting
